import React from 'react';
import { useVideosListQuery } from 'src/modules/videos/hooks/useVideosListQuery';
import { useFavoriteVideosQuery } from 'src/modules/user/hooks/useFavouriteVideosQuery';
import { ShowcaseListRenderComponentProps } from 'src/modules/materials/models/showcase';
import { SliderSectionRender } from 'src/modules/materials/components/ShowcasePage/renderers/SliderSectionRender';
import { videosBasicGqlQuery } from 'src/modules/videos/graphql/videos-basic.query';

export const VideoFavouritesContainer = ({
  section,
}: ShowcaseListRenderComponentProps) => {
  const favoriteVideos = useFavoriteVideosQuery();
  const favoriteVideosIds = favoriteVideos.data;

  const videos = useVideosListQuery(
    videosBasicGqlQuery,
    {
      filters: {
        id: {
          _in: favoriteVideos.data ?? [],
        },
        status: { _eq: 'published' },
      },
      limit: 10,
    },
    {
      enabled: !!favoriteVideosIds,
    },
  );

  return favoriteVideosIds?.length ? (
    <SliderSectionRender
      section={{
        ...section,
        variables: { limit: 10, itemsToQuery: ['videos'] },
      }}
      items={videos.data}
      isLoading={videos.isLoading}
    />
  ) : null;
};
